import { Pipe, PipeTransform } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';

@Pipe({
    name: 'phoneMask',
    standalone: false
})
export class PhoneMaskPipe implements PipeTransform {

    constructor(private textMask: NgxMaskPipe) { }

    transform(value: any, args?: any): any {
        return this.textMask.transform(value, '(000) 000-0000');
    }
}
